/**
 * Generated by orval v8.7.0 🍺
 * Do not edit manually.
 * Agentiq.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  AuditEventDto,
  ListAuditEventsRequest
} from '../control-api.schemas';

import { orvalControlFetch } from '../../orval-fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getPostApiAuditEventsUrl = () => {




  return `/api/audit-events`
}

export const postApiAuditEvents = async (listAuditEventsRequestNull: ListAuditEventsRequest | null, options?: RequestInit): Promise<AuditEventDto[]> => {

  return orvalControlFetch<AuditEventDto[]>(getPostApiAuditEventsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      listAuditEventsRequestNull,)
  }
);}




export const getPostApiAuditEventsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuditEvents>>, TError,{data: ListAuditEventsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof postApiAuditEvents>>, TError,{data: ListAuditEventsRequest | null}, TContext> => {

const mutationKey = ['postApiAuditEvents'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiAuditEvents>>, {data: ListAuditEventsRequest | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiAuditEvents(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiAuditEventsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiAuditEvents>>>
    export type PostApiAuditEventsMutationBody = ListAuditEventsRequest | null
    export type PostApiAuditEventsMutationError = unknown

    export const usePostApiAuditEvents = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiAuditEvents>>, TError,{data: ListAuditEventsRequest | null}, TContext>, request?: SecondParameter<typeof orvalControlFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiAuditEvents>>,
        TError,
        {data: ListAuditEventsRequest | null},
        TContext
      > => {
      return useMutation(getPostApiAuditEventsMutationOptions(options), queryClient);
    }
